/* Maison — global effects: image skeleton loader + per-item reveal-on-scroll.
   Scoped to .section-maison-* sections. Re-runs on Shopify section load. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  // Top-level "blocks" inside a section that should fade in individually.
  var ITEM_SEL = [
    '.mfx-reveal-item',
    '[class*="__card"]',
    '[class*="__item"]',
    '[class*="__step"]',
    '[class*="__head"]',
    '[class*="__media"]',
    '[class*="__img"]',
    '[class*="__body"]',
    '[class*="__subtitle"]',
    '[class*="__intro"]',
    '[class*="__closing"]',
    '[class*="__col"]',
    '[class*="__actions"]'
  ].join(',');

  /* ---------- Image skeleton ---------- */
  function markImage(img) {
    if (img.dataset.mfx) return;
    img.dataset.mfx = '1';
    img.classList.add('mfx-img');
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    }
  }

  /* ---------- Reveal on scroll ---------- */
  var io = (!reduce && 'IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries, obs) {
        each(entries, function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 })
    : null;

  function markReveal(el, index) {
    if (el.dataset.mfxReveal) return;
    el.dataset.mfxReveal = '1';
    el.classList.add('mfx-reveal');
    if (!reduce && index) {
      el.style.transitionDelay = Math.min(index * 80, 480) / 1000 + 's';
    }
    if (reduce) { el.classList.add('is-visible'); return; }
    var r = el.getBoundingClientRect();
    if (r.top < (window.innerHeight || 0) * 0.92) { el.classList.add('is-visible'); }
    else if (io) { io.observe(el); }
    else { el.classList.add('is-visible'); }
  }

  function revealSection(section) {
    if (/section-maison-(header|announcement|footer)/.test(section.className || '')) return;
    var candidates = section.querySelectorAll(ITEM_SEL);
    var list = [];
    each(candidates, function (el) {
      var p = el.parentElement, nested = false;
      while (p && p !== section) {
        if (p.matches && p.matches(ITEM_SEL)) { nested = true; break; }
        p = p.parentElement;
      }
      if (!nested) list.push(el);
    });
    if (!list.length) list = [section.firstElementChild || section];
    each(list, function (el, i) { markReveal(el, i); });
  }

  function init(scope) {
    var sections = (scope.matches && scope.matches('[class*="section-maison-"]'))
      ? [scope]
      : scope.querySelectorAll('[class*="section-maison-"]');
    each(sections, revealSection);
    each(document.querySelectorAll('[class*="section-maison-"] img'), markImage);
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-init the reloaded section.
  document.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();
